import React, { useEffect, useState } from 'react';

import './styles.css';

import { months } from '../../../../../../functions/formatDate';

import { FaArrowUp, FaArrowDown } from 'react-icons/fa';

export default function MovementsItem(props) {
    const [date, setDate] = useState("");

    useEffect(() => {
        if (props.date) {
            let auxDate = props.date.split('-');
            setDate(`${auxDate[2]} de ${months[Number(auxDate[1]) - 1].slice(0, 3)} de ${auxDate[0]}`);
        }
    }, [props.date]);

    return (
        <li className={"movements-item-component" + (props.type === 1 ? " red" : (props.type === 0 ? " green" : ""))}>
            {
                props.type === 1 ?
                    <FaArrowUp />
                    :
                    <FaArrowDown />
            }
            <div className='infos'>
                <p className='tittle'><b>{props.tittle}</b></p>
                <p>{props.description}</p>
                {
                    props.author ?
                    <p><b>Autor: </b>{props.author.nome}</p>
                    :
                    null
                }
            </div>
            <p><b>{date}</b></p>
        </li>
    )
}